export const ReportRoutes = {
  INDEX: "/reports",
} as const;
